import Api from 'src/api/Base'

class GetPendingSspsaTasks extends Api {
  requestUrl = `/api/SspsaTask`
}

export default GetPendingSspsaTasks
